/**
 * Утилиты форматирования — числа, дельты, валюта.
 */

import {env} from '@services/utils';

export const formatNumber = (v: number): string => new Intl.NumberFormat('ru-RU').format(v);

/**
 * Денежная сумма с подходящей по стране единицей. Без копеек —
 * округляем до целого, в кассовых отчётах дробная часть не нужна.
 */
const CURRENCY_UNIT_BY_COUNTRY: Record<string, string> = {
  kg: 'сом',
  uz: 'сум',
  ru: '₽',
};

export const currencyUnit = (): string =>
  CURRENCY_UNIT_BY_COUNTRY[(env.VITE_COUNTRY_CODE ?? '').toLowerCase()] ?? 'сом';

export const formatMoney = (v: number, opts: {unit?: boolean} = {}): string => {
  const withUnit = opts.unit !== false;
  const num = formatNumber(Math.round(v));
  return withUnit ? `${num} ${currencyUnit()}` : num;
};

/** Тыйыны → сумма, копейки только когда они есть: «824,5 сом», «12 000 сом» */
export const formatTiyin = (tiyin: number): string =>
  `${new Intl.NumberFormat('ru-RU', {maximumFractionDigits: 2}).format(tiyin / 100)} ${currencyUnit()}`;

/** Крупные счётчики коротко: 250 077 → «250 тыс.», 1 234 567 → «1,2 млн» */
export const formatCompact = (v: number): string =>
  new Intl.NumberFormat('ru-RU', {notation: 'compact', maximumFractionDigits: 1}).format(v);

export const formatDelta = (percent: number): string => {
  const sign = percent > 0 ? '+' : '';
  return `${sign}${percent}%`;
};

export type DeltaTone = 'up' | 'down' | 'neutral';

export const deltaTone = (percent: number): DeltaTone => {
  if (percent > 0) return 'up';
  if (percent < 0) return 'down';
  return 'neutral';
};
